<script setup lang="ts">
const { siteOptions } = useSiteOptions();
</script>

<template>
  <a :href="siteOptions.shipping_url" class="color-primary flex items-center justify-center gap-2 p-2">
    <span class="i-local-shipping size-6 shrink-0" />
    <div class="text-center text-sm font-semibold leading-tight lg:text-lg" v-html="siteOptions.messages.free_shipping" />
    <span class="i-local-shipping size-6 shrink-0" />
  </a>
</template>
